import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import LevelCard from './LevelCard';
import { StaffPermissionsLevelStorageKey } from '../../../../constants/localStorage';
import { useAPIContext } from '../../../../utilities/Contexts/DCGAutomationPagesContextProvider';

const LevelsGrid = () => {
    const { navigateToPage } = useAPIContext();
    const [selectedLevel, setSelectedLevel] = useState(() => {
        const selectedLevel = localStorage.getItem(StaffPermissionsLevelStorageKey);
        return selectedLevel || null;
    });
    useEffect(() => {
        if (selectedLevel) {
            localStorage.setItem(StaffPermissionsLevelStorageKey, selectedLevel);
        }
    }, [selectedLevel]);
    const levelsData = [
        {
            level: "Level 1",
            description: "Only a Portal Admin has full control over portal data, label creation and more.",
            portalTitle: "Portal",
            portalContent: "Managers can access training tools, view device info, and add prep lists by location.",
            appTitle: "App",
            topBarColor: "#bfbdbf",
            appContent: (
                <>
                    <ul className="centered-list">
                        <li>No access to make changes.</li>
                        <li>No password required.</li>
                    </ul>
                </>
            )
        },
        {
            level: "Level 2",
            description: "Portal Admin allows Managers to update menu item price and add users to locations.",
            portalTitle: "Portal",
            portalContent: "In addition to Level 1, Managers can update retail price and users.",
            appTitle: "App",
            topBarColor: "rgb(10,58,72, 43%)",
            appContent: (
                <>
                    <ul className="centered-list">
                        <li>Limited access to make changes.</li>
                        <li>Password required.</li>
                    </ul>
                </>
            )
        },
        {
            level: "Level 3",
            description: "Portal Admin relies fully on Managers to add and manage data in the portal.",
            portalTitle: "Portal",
            portalContent: "In addition to Level 2, Managers have full functionality access. (Portal Admin can override Manager)",
            appTitle: "App",
            topBarColor: "rgb(10,58,72, 70%)",
            appContent: (
                <>
                    <ul className="centered-list">
                        <li>Full access to make changes.</li>
                        <li>Password required.</li>
                        <li>Users can reset passwords.</li>
                    </ul>
                </>
            )
        }
    ];

    const handleSelect = (level) => {
        setSelectedLevel(level);
    };
    const btnClick = () => {
        if (selectedLevel !== "Level 3") {
            navigateToPage('personaAccountRegistrationPage');
        } else {
            navigateToPage('level3Confirmation');
        }
    }

    return (
        <>
            <Container className="mt-4">
                <Row className="d-flex align-items-stretch">
                    {levelsData.map((levelData, index) => (
                        <Col md="4" key={index}>
                            <LevelCard
                                className="levels-grid"
                                isSelected={selectedLevel === levelData.level}
                                index={index}
                                level={levelData.level}
                                description={levelData.description}
                                portalTitle={levelData.portalTitle}
                                portalContent={levelData.portalContent}
                                appTitle={levelData.appTitle}
                                appContent={levelData.appContent}
                                topBarColor={levelData.topBarColor}
                                onSelect={() => handleSelect(levelData.level)}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
            <Container className="text-center">
                {selectedLevel && <Button onClick={btnClick} color="primary">NEXT</Button>}
            </Container>
        </>
        
    );
};

export default LevelsGrid;